import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// import openFolderIcon from '../../../../portal/img/open-folder3.png';
// import closedFolderIcon from '../../../../portal/img/closed-folder3.png';

export default class Tree extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            select: null,
            selected: props.selected ?? '',
            groupState: {}, // groupId => open/close
            allOpen: false,
        };
        this.tree = React.createRef();

        this.openLevel = null;
        this.groupInitState = [];
        if (props.openLevel != undefined) {
            this.openLevel = props.openLevel;
        }
    }

    componentDidMount() {
        this.openLevel = null;
        this.setState({
            groupState: this.groupInitState,
        });

        if (this.state.select == null) {
            const selected = this.tree.current.querySelector('.acmTreeGroupSelected');
            // get first item with class acmTreeGroupHeader
            const targetTop = selected.querySelector('.acmTreeGroupHeader');
            targetTop.classList.add('selectedGroup');
            this.setState({select: targetTop});
        }
    }

    selectedRecursive(group) {
        if (group.id === this.state.selected) {
            return true;
        }
        return group.children?.some((child) => this.selectedRecursive(child));
    }

    createGroup(group, first = false, level=0) {
        let open = true;
        if (this.openLevel != null && level <= this.openLevel) {
            open = true;
            this.groupInitState[group.id] = 'open';
        }

        if (this.state.allOpen == true) {
            open = true;
        }

        if (this.state.groupState[group.id] == 'close') {
            open = false;
        }

        if (group.id !== this.state.selected && this.selectedRecursive(group)) {
            open = true;
        }

        const renderTree = [];
        group.children.forEach((child) => {
            if (child.type == 'group') {
                renderTree.push(this.createGroup(child, false, level+1));
            } else if (child.type == 'record' || child.type === undefined) {
                renderTree.push(this.createRecord(child, open, first));
            }
        });

        const iconStyle = {};
        // const brightness = 0.4 + (level * 0.3);
        // const iconStyle = {
        //     filter: `brightness(${brightness})`,
        // };

        return (
            <div
                className={classNames({
                    acmTreeGroup: true,
                    acmTreeGroupMain: first === true,
                    acmTreeGroupSelected: this.state.selected === group.id,
                })}
                key={group.id}
            >
                <div
                    className={'acmFileLine ' + (open ? 'orderTriangleBottom' : 'orderTriangleTop')}
                    onClick={(e) => this.toggleGroup(e, group.id, true)} />
                <div className='acmTreeContentLine' />
                <div
                    className="acmTreeGroupHeader"
                    onClick={(e) => {
                        if (group?.id || this.props.module !== 'aon_event_response_categories') {
                            this.toggleGroup(e, group.id);
                        } else {
                            this.toggleGroup(e, group.id, true);
                        }
                    }}
                >
                    <div
                        className={'acmTreeFolderIcon ' + (open ? 'open' : 'closed')}
                        style={open ?
                            {backgroundImage: 'url(\'/portal/img/open-folder3.png\')', ...iconStyle} :
                            {backgroundImage: 'url(\'/portal/img/closed-folder3.png\')', ...iconStyle}
                        }
                    />
                    {this.props.multiple == true && (
                        <input
                            className="acmTreeInput"
                            onChange={(e) => this.addToSelectChange(e, group.id)}
                            type="checkbox"
                        />
                    )}

                    <span className='treeGroupName'>{group.name}</span>
                </div>
                <div
                    className={
                        open === true ?
                            'acmTreeGroupContent' :
                            'acmTreeGroupContent acmTreeGroupContentClose'
                    }
                >
                    {renderTree}
                </div>
            </div>
        );
    }

    createRecord(child, open = false, first = false) {
        return (
            <div
                className="acmTreeRecord"
                onMouseEnter={(e) => this.centerHover(e)}
                onClick={(e) => this.selectRecord(e, child.id)}
                key={'record' + child.id}
            >
                <div className={'acmFileLine ' + (open ? 'orderTriangleBottom' : 'orderTriangleTop')} />
                <div className={'acmTreeContentLine ' + (first ? 'A' : 'B')} />
                <div className="acmTreeFileIcon" />
                {this.props.multiple == true && (
                    <input
                        className="acmTreeInput"
                        onChange={(e) => this.addToSelectChange(e, child.id)}
                        type="checkbox"
                    />
                )}
                <span>{child.name}</span>
            </div>
        );
    }

    toggleGroup(e, id, arrow = false) {
        const state = this.state.groupState;
        let data = {};
        let target = e.target;

        console.log('toggleGroup', id, arrow, state[id]);

        // if is arrow select target as class acmTreeGroupHeader in same div
        // if arrow just open dont load data
        if (arrow === true) {
            target = e.target.parentElement.querySelector('.acmTreeGroupHeader');

            if (state[id] === 'close') {
                state[id] = 'open';
            } else if (state[id] === 'open' || state[id] === undefined) {
                state[id] = 'close';
            }
            data = {groupState: state};
            console.log('toggleGroup', {...state});
            this.setState(data);
            return;
        }

        state[id] = 'open';
        if (!target.classList.contains('acmTreeGroupHeader')) {
            target = target.closest('.acmTreeGroupHeader');
        }

        this.state.select.classList.remove('selectedGroup');
        target.classList.add('selectedGroup');

        data = {groupState: state, select: target, selected: id};
        if (this.props.onSelectGroup != undefined) {
            this.props.onSelectGroup(id);
        }
        if (this.props.onChange != undefined) {
            this.props.onChange(e, 'group', id);
        }

        this.setState(data);
    }

    selectRecord(e, id) {
        let target = e.target;
        if (!target.classList.contains('acmTreeRecord')) {
            target = target.closest('.acmTreeRecord');
        }
        // add class "selected" to selected target
        target.classList.add('selectedGroup');
        this.setState({select: target});

        if (this.props.onSelectRecord != undefined) {
            this.props.onSelectRecord(id);
        }
        if (this.props.onChange != undefined) {
            this.props.onChange(e, 'record', id);
        }
    }

    closeAll() {
        this.setState({
            select: null,
            groupState: {},
            selected: '',
            allOpen: false,
        });
    }

    openAll() {
        const children = this.props.data;
        const promise = new Promise((resolve, rejects) => {
            const ids = {};
            this.openAllRecursive(children, ids);
            resolve(ids);
        });
        promise.then((ids) => {
            this.setState({groupState: ids, allOpen: true});
        });
    }

    openAllRecursive(groups, pole) {
        groups.forEach((element) => {
            pole[element.id] = 'open';
            this.openAllRecursive(element.children, pole);
        });
    }

    addToSelectChange(e, id) {
        const target = e.target;
        if (target.checked) {
            let parent = e.target.closest('.acmTreeRecord');
            if (parent == null) {
                parent = e.target.closest('.acmTreeGroup');
            }
            console.log(parent);
        } else {
            console.log('ne');
        }
    }

    render() {
        const data = this.props.data;
        const tree = this.createGroup({children: data, id: 'main'}, true);
        return (
            <div
                ref={this.tree}
                className={'acmTree'}
            >
                <div className="acmTreeMenu">
                    <div className="acmTreeHeader">
                        {this.props.header !== undefined && this.props.header}
                    </div>
                    <div className="acmTreeMenuButtons">
                        {this.state.allOpen ? (
                            <div
                                className="acmTreeCloseAllIcon orderTriangleTop"
                                title="Close all"
                                onClick={() => this.closeAll()}
                            />
                        ) : (
                            <div
                                className="acmTreeOpenAllIcon orderTriangleBottom"
                                title="Open all"
                                onClick={() => this.openAll()}
                            />
                        )}
                    </div>
                </div>
                {tree}
            </div>
        );
    }
}

Tree.propTypes = {
    data: PropTypes.any,
    header: PropTypes.any,
    multiple: PropTypes.bool,
    onChange: PropTypes.func,
    onSelectGroup: PropTypes.func,
    onSelectRecord: PropTypes.func,
    openLevel: PropTypes.any,
    selected: PropTypes.any,
    module: PropTypes.string,
};
